import { type DailyGameStatus } from '@/pages/days-streak-page/types';

import { type UserReferral } from '@/entities/user/model/friends.types';
import type { SocialMedia, UserType } from '@/entities/user/model/user.types';
import { type ExpiredBooster } from '@/entities/user/model/wallet.types';
import { type Prize } from '@/entities/wheel/model/wheel.types';

import { type PageableRes } from '@/shared/types/common';

import { api } from '../api';

export const getUser = async (): Promise<UserType> => {
  return (await api.get('v1/user/profile')).data;
};

export const fillProfile = async (sex: string, age: string, findOutPlaydeck: string) => {
  return await api.put('v1/user/profile', {
    sex,
    findOutPlaydeck,
    age,
  });
};

export const makeSocialIntegration = async (
  provider: SocialMedia,
  token: string,
  uuid?: string | null
) => {
  const response = await api.post('v1/social/user/info', {
    provider,
    token,
    uuid,
  });

  return response;
};

export const getExpiredPlaycoinBooster = () => {
  return api
    .get<ExpiredBooster | undefined>('v1/boosters/expired')
    .then((res) => res.data);
};

export const getUserReferrals = async (
  page: number
): Promise<PageableRes<UserReferral[]>> => {
  return (await api.get(`v2/user/referrals?size=20&page=${page}`)).data;
};

export const setUserFlags = async (flags: Record<string, boolean>) => {
  return (await api.put('v1/user/profile', { flags })).data;
};

export const getDailyGameStatus = async () => {
  return (await api.get<DailyGameStatus>('v3/streak/daily/reward')).data;
};

export const grabReward = () => {
  return api.put('v1/streak/daily/reward/grab');
};

export const callTaskAction = (id: number) => {
  return api.post(`v2/wheel/tasks/action?taskId=${id}`);
};

export const grabRetentionPrize = async (): Promise<Prize> => {
  return (await api.post('v1/retention/prize')).data;
};

export const setUserCustomFlags = async (flags: {
  [key: string]: any;
}): Promise<void> => {
  return await api.put('v1/user/profile', { flags });
};

export const reportUserViolation = async (violations: { isConsoleOpened: boolean }) => {
  return await api.put('/v1/user/profile', { violations }).then((res) => res.data);
};

export const rateGame = async (gameKey: number | string, rating: number) => {
  return await api.post('v1/user/rategame', { gameKey, rating }).then((res) => res.data);
};
